export default __webpack_public_path__ + "static/media/home_product_img3_Cn.ed300333.webp";